module.exports = __webpack_public_path__ + "fonts/GT-America-Standard-Regular.da046b8e.ttf";